// extracted by mini-css-extract-plugin
export default {"DTCQuery":"DTCQuery_DTCQuery__kSchG","DTCQuery--Buttons":"DTCQuery_DTCQuery--Buttons__XFTBF"};